import { ACCESS_TOKEN, useLocalStorage, useToken } from '@hsp/react-hooks';
import { IAuthenticationToken, isNotDefined } from '@hsp/utilities';

import { authenticationService } from 'services';
import { TokenExpiredError, TokenMissingError } from 'types/errors';

export const useExtendToken = () => {
  const [token] = useLocalStorage<IAuthenticationToken>(ACCESS_TOKEN, null);
  const { isExpired } = useToken(token);

  const extend = async () => {
    if (isNotDefined(token)) {
      throw new TokenMissingError();
    }

    if (isExpired) {
      throw new TokenExpiredError();
    }

    return await authenticationService.extend(token);
  };

  return extend;
};
